import { Component } from 'react';

import { Box, Divider, H4 } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import { ContentWrapper } from '../../components/ContentWrapper';

class Docs extends Component {
  public render() {
    return (
      <ContentWrapper>
        <ContentCard title="API Documentation" borderRadius="roundedSquare">
          <Box>Please see our in-depth documentation on how to use the Opendoor API.</Box>
          <Box mt={2}>
            <a target="_blank" href="https://docs.opendoor.com" rel="noopener noreferrer">
              <strong>Open API Docs →</strong>
            </a>
          </Box>
          <Box mt={7}>
            <Divider />
          </Box>
          <Box mt={7}>
            <H4 color="neutrals100" mb={2}>
              Questions?
            </H4>
            If you have any questions or issues using the API or suggestions for imporovements,
            please reach out to us at <a href="mailto:api@opendoor.com">api@opendoor.com</a>
          </Box>
        </ContentCard>
      </ContentWrapper>
    );
  }
}

export default Docs;
